<template>
  <el-form
    ref="ruleForm"
    :model="formData"
    label-width="0"
    class="error-form"
    size="small"
  >
    <el-table :data="formData.arr" border>
      <!--车型-->
      <el-table-column :label="$t('vehicle.modelLabel')" min-width="100">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('vehicle.modelLabel') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <div>
            <el-form-item
              :prop="'arr.' + scope.$index + '.vehicleType'"
              :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-select
                v-model="scope.row.vehicleType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--      混合报价-->
      <!--      <el-table-column :label="$t('basicData.WhetherToMixQuotes')" min-width="160">-->
      <!--        <template #header>-->
      <!--          <div>-->
      <!--            <span style="color: red;">*</span>-->
      <!--            <span>{{ $t('basicData.WhetherToMixQuotes') }}</span>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--        <template v-slot="scope">-->
      <!--          <el-form-item-->
      <!--            :prop="'arr.' + scope.$index + '.isMix'"-->
      <!--            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"-->
      <!--          >-->
      <!--            <el-select-->
      <!--              v-model="scope.row.isMix"-->
      <!--              filterable-->
      <!--              clearable-->
      <!--              :placeholder="$t('operationCenter.PleaseSelect')"-->
      <!--              style="width: 100%;"-->
      <!--              @change="changeIsMix"-->
      <!--            >-->
      <!--              <el-option-->
      <!--                v-for="item in ISMIX_START"-->
      <!--                :key="item.value"-->
      <!--                :label="item.label"-->
      <!--                :value="item.value"-->
      <!--                :disabled="isMixDisabled(scope.$index, item.value)"-->
      <!--              />-->
      <!--            </el-select>-->
      <!--          </el-form-item>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--报价模式-->
      <el-table-column :label="$t('basicData.报价模式')" min-width="160">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.报价模式') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'arr.' + scope.$index + '.quotationMode'"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <!--            @change="changeQuotationMode(scope, scope.$index)"-->
            <el-select
              v-model="scope.row.quotationMode"
              :placeholder="$t('basicData.PleaseSelect')"
              style="width: 100%;"
              clearable
            >
              <el-option
                v-for="item in QUOTATION_MODEL"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
              <!--              :disabled="isOptionDisabled(scope.$index, item.value)"-->
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <!--公里数开始KM（不包含）-->
      <el-table-column :label="$t('basicData.KilometersStartKM')" min-width="160">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.KilometersStartKM') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            v-if="[5, 6].includes(scope.row.quotationMode)"
            :prop="'arr.' + scope.$index + '.startDistance'"
            :rules="{
              required: true,
              negative: '',
              suffix: 2,
              negative1: 1,
              package: scope.row.endDistance,
              validator: priceType,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.startDistance" />
          </el-form-item>
        </template>
      </el-table-column>
      <!--公里数结束KM（包含）-->
      <el-table-column :label="$t('basicData.MileageEndKM')" min-width="160">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.MileageEndKM') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            v-if="[5, 6].includes(scope.row.quotationMode)"
            :prop="'arr.' + scope.$index + '.endDistance'"
            :rules="{
              required: true,
              negative: '',
              suffix: 2,
              negative1: 2,
              package: scope.row.startDistance,
              validator: priceType,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.endDistance" />
          </el-form-item>
        </template>
      </el-table-column>
      <!--费用类型-->
      <el-table-column :label="$t('basicData.ExpenseType')" min-width="160">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.ExpenseType') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'arr.' + scope.$index + '.feeTypeCode'"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-select
              v-model="scope.row.feeTypeCode"
              :placeholder="$t('basicData.PleaseSelect')"
              style="width: 100%;"
            >
              <el-option
                v-for="item in feeTypeList"
                :key="item.id"
                :label="item.displayName + '(' + item.code + ')'"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <!--价格-->
      <el-table-column :label="$t('basicData.Price')" min-width="100">
        <template #header>
          <div>
            <span style="color: red;">*</span>
            <span>{{ $t('basicData.Price') }}</span>
          </div>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'arr.' + scope.$index + '.price'"
            :rules="{
              required: true,
              negative: '',
              suffix: 2,
              negative1: '',
              validator: priceType,
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="scope.row.price" />
          </el-form-item>
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column :label="$t('basicData.operate')" width="100" fixed="right">
        <template v-slot="scope">
          <!--确定删除吗？-->
          <el-popconfirm
            :title="$t('basicData.AreYouSureYouWantToDelete')"
            @confirm="handleDel(scope.$index, 'collectFeesList')"
          >
            <!--删除-->
            <template #reference>
              <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { QUOTATION_MODEL } from '@/views/finance/utils';
// import { ISMIX_START } from '@/views/finance/enums';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    quotationMode: {
      type: [Number, String],
      default: 0
    },
    modelList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    // 校验正整数保留两位小数
    const priceType = (rule, value, callback) => {
      const regex = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;

      // 数据是否为空
      if (value !== null && value !== '' && value !== undefined) {
        // 格式校验
        if (!regex.test(value)) {
          return callback(new Error(this.$t('basicData.NumericWithTwoDecimals'))); // '格式不正确'
        }
        if (parseFloat(value) <= 0) {
          return callback(new Error(this.$t('basicData.MustBeGreaterThan0'))); // 必须大于0
        }
        // 数据比较
        if (rule.negative1 === 2) {
          if (parseFloat(value) <= parseFloat(rule.package)) {
            return callback(new Error(this.$t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
          }
          return callback();
        } else {
          if (parseFloat(value) >= parseFloat(rule.package)) {
            return callback(new Error(this.$t('basicData.MustLessThanEndValue'))); // 必须小于结束值
          }
          return callback();
        }
      } else {
        // 必填
        if (required) {
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
        return callback();
      }
    };

    return {
      formData: {
        arr: []
      },
      priceType,
      // ISMIX_START, // 状态
      QUOTATION_MODEL // 报价模式
    };
  },

  watch: {
    tableData: {
      handler(val, oldVal) {
        console.log('子组件监听300', val, oldVal);
        if (oldVal === undefined) {
          // 第一次赋值
          this.formData.arr = [];
          return;
        }

        if (val.length === 0 && oldVal.length === 0) {
          return;
        }

        // 新的值与旧的值一样
        if (JSON.stringify(val) === JSON.stringify(this.formData.arr)) {
          // console.log('新的值与旧的值一样');
          return;
        }
        this.formData.arr = cloneDeep(this.tableData);
      },
      deep: true,
      immediate: true
    },

    // table数据变化通知父组件
    formData: {
      handler(val, oldVal) {
        console.log('子组件提交', val, oldVal);
        if (!oldVal || !val) {
          return;
        }
        // console.log('父元素提交', val.arr);
        this.$emit('change', val.arr);
      },
      deep: true
      // immediate: true
    }
  },

  methods: {
    // 提交校验
    submitForm() {
      return this.$refs['ruleForm'].validate().then(() => {
        return true;
      }).catch(res => {
        return false;
      });
    },

    // 删除
    handleDel(index) {
      this.formData.arr.splice(index, 1);
    }
    // 混合报价状态
    // changeIsMix(val) {
    //   // 重置报价模式
    //   this.formData.arr.forEach((item, index) => {
    //     item.isMix = val;
    //     item.quotationMode = '';
    //   });
    // },
    // isMixDisabled(index, val) {
    //   try {
    //     const { isMix } = this.formData.arr[index];
    //     if (isMix === '') {
    //       return false;
    //     }
    //
    //     // 检查此选项是否已被其他行选中
    //     for (const key in this.ISMIX_START) {
    //       // console.log('key', key, val);
    //       if (key !== val) {
    //         return true;
    //       }
    //     }
    //   } catch (error) {
    //     console.log('error', error);
    //     return false;
    //   }
    // },
    /**
     * 修改报价模式
     */
    // changeQuotationMode(val) {
    // 修改当前车线下table数据、公里数
    // this.formData.arr.forEach((item, index) => {
    //   const { quotationMode, isMix } = item;
    //   if (!isMix) {
    //     item.quotationMode = val;
    //   }
    //
    //   if (val === 4) {
    //     item.startDistance = '';
    //     item.endDistance = '';
    //   }
    // });
    // }
    // 报价模式选中后，无法选择其他报价模式
    // isOptionDisabled(currentIndex, optionValue) {
    //   try {
    //     const { quotationMode, isMix } = this.formData.arr[currentIndex];
    //     // 选择混合报价，就不能选择固定报价模式
    //     if (isMix && optionValue === 4) {
    //       return true;
    //     }
    //     if (!quotationMode) {
    //       return false;
    //     }
    //     // 如果当前行已经选择了这个选项，不禁用（允许取消选择）
    //     if (quotationMode && quotationMode === optionValue) {
    //       return false;
    //     }
    //
    //     // 检查此选项是否已被其他行选中
    //     for (const key in this.QUOTATION_MODEL) {
    //       console.log('key', key);
    //       // 混合报价可以多选
    //       if (isMix) {
    //         return false;
    //       } else if (key !== optionValue) {
    //         return true;
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     return false;
    //   }
    // }
  }
};
</script>

